import { render, staticRenderFns } from "./NotificationTemplatePreview.vue?vue&type=template&id=72a679a9"
import script from "./NotificationTemplatePreview.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports